import React from "react";
import { Skeleton } from "@mui/material";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { useAlterarTemperatura } from "services/api/AppWeb_Lead/alterar-temperatura";
import * as Styles from "./styles";

interface Props {
  value: "Frio" | "Morno" | "Quente" | undefined;
  idLeadCorretor: string | undefined;
  idLead: string | undefined;
  readOnly?: boolean;
}

export default function SliderTemperature(props: Props) {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const [temperaturaDisplay, setTemperaturaDisplay] = React.useState<
    "Frio" | "Morno" | "Quente" | undefined
  >(undefined);
  const [codigoTemperatura, setCodigoTemperatura] = React.useState<1 | 2 | 3>(
    1
  );
  const [sliderValue, setSliderValue] = React.useState<number>(50);

  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";

  const { mutate, isLoading } = useAlterarTemperatura({
    idLeadCorretor: props.idLeadCorretor,
    body: { idLead: props.idLead, codigoTemperatura },
  });

  const hadleChangeTemp = (value: number) => {
    if (value < 25) {
      setCodigoTemperatura(3);
      setTemperaturaDisplay("Frio");
      mutate();
    }
    if (value >= 25 && value < 75) {
      setCodigoTemperatura(1);
      setTemperaturaDisplay("Morno");
      mutate();
    }
    if (value > 75) {
      setCodigoTemperatura(2);
      setTemperaturaDisplay("Quente");
      mutate();
    }
  };

  const temperature = (value: "Frio" | "Morno" | "Quente" | undefined) => {
    switch (value) {
      case "Frio":
        return { value: 10, color: "#2698F1" };
      case "Morno":
        return {
          value: 50,
          color:
            "linear-gradient(90deg, #2698F1 0%, #FCCF2F 50.51%, #FCCF2F 97.97%) !important",
        };
      case "Quente":
        return {
          value: 100,
          color:
            "linear-gradient(90deg, #2698F1 0%, #FCCF2F 50.51%, #FC2F2F 97.97%) !important",
        };
      default:
        return {
          value: 100,
          color:
            "linear-gradient(90deg, #2698F1 0%, #FCCF2F 50.51%, #FC2F2F 97.97%) !important",
        };
    }
  };

  React.useEffect(() => {
    setTemperaturaDisplay(props.value);
    if (props.value) {
      setSliderValue(temperature(props.value).value);
    }
  }, [props.value]);
  return (
    <>
      <p>Temperatura: {temperaturaDisplay ?? props.value}</p>
      {props.value ? (
        <Styles.StyledSlider
          disabled={!isCorretor || props.readOnly}
          background={temperature(temperaturaDisplay ?? props.value).color}
          value={sliderValue}
          onChange={(event: any, newValue: number | number[]) => {
            setSliderValue(newValue as number);
          }}
          onChangeCommitted={(event: any, newValue: number | number[]) =>
            hadleChangeTemp(newValue as number)
          }
        />
      ) : (
        <Skeleton variant="rounded" width="100%" height={5} />
      )}
    </>
  );
}
